import React from 'react';
import { Link } from 'react-router-dom';
import { useLeaveRulesDetail } from './hooks/useLeaveRulesDetail';
import LeaveRuleDetailsTable from './components/LeaveRuleDetailsTable';
import LeaveRuleDetailModal from './components/LeaveRuleDetailModal';

export default function LeaveRulesDetailScreen() {
  const { state, actions } = useLeaveRulesDetail();
  const {
    rule,
    details,
    isLoading,
    isModalOpen,
    editingDetailId,
    detailForm,
    isSavingDetail,
    leaveTypeOptions,
    genderOptions,
    accumulateOptions,
  } = state;

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner matching Screenshot 5 */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            Leave Rules of {rule?.name || '...'}
          </h1>
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/payroll/leave-rules"
            className="inline-flex items-center gap-1.5 rounded-xl border border-outline-variant/30 bg-surface-container-lowest px-4 py-2.5 text-xs font-bold text-on-surface-variant hover:text-primary hover:bg-surface-container-low transition shadow-xs cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">arrow_back</span>
            <span>Back to Rules List</span>
          </Link>

          <button
            type="button"
            onClick={actions.openAddModal}
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-xs font-bold text-on-primary shadow-sm hover:bg-primary/90 transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">add</span>
            <span>Add Leave Quota</span>
          </button>
        </div>
      </section>

      {/* Details Table Section matching Screenshot 5 */}
      <section className="space-y-4">
        <LeaveRuleDetailsTable
          records={details}
          isLoading={isLoading}
          onEdit={actions.openEditModal}
          onDelete={actions.handleDeleteDetail}
          onAddNew={actions.openAddModal}
        />

        {/* Table Footer */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {details.length} quota entries configured for &quot;{rule?.name}&quot;
          </p>
        </div>
      </section>

      {/* Add / Edit Detail Modal */}
      <LeaveRuleDetailModal
        isOpen={isModalOpen}
        isEdit={Boolean(editingDetailId)}
        ruleName={rule?.name}
        form={detailForm}
        isSaving={isSavingDetail}
        leaveTypeOptions={leaveTypeOptions}
        genderOptions={genderOptions}
        accumulateOptions={accumulateOptions}
        onPatch={actions.patchDetailForm}
        onSave={actions.handleSaveDetail}
        onClose={actions.closeModal}
      />
    </div>
  );
}
